export enum StoryMilestone {
  NotStarted = 'NotStarted',
  Started = 'Started',
  PaycheckSet = 'PaycheckSet',
  GrowthSeen = 'GrowthSeen',
  PurchasePaid = 'PurchasePaid',
  Complete = 'Complete',
}

export enum PayCadence {
  Weekly = 'Weekly',
  Biweekly = 'Biweekly',
  Monthly = 'Monthly',
}

export enum LedgerKind {
  Payroll = 'Payroll',
  Payment = 'Payment',
  Cashback = 'Cashback',
  Interest = 'Interest',
}

export enum LedgerFilter {
  All = 'All',
  Savings = 'Savings',
  Rewards = 'Rewards',
}

export interface StoryInput {
  perPaycheckCents: number;
  cadence: PayCadence;
  paycheckCount: number;
}

export interface PaycheckRow {
  index: number;
  dateLabel: string;
  depositCents: number;
  savingsCents: number;
  availableCents: number;
  heldCents: number;
  interestThisPeriodCents: number;
  interestToDateCents: number;
}

export interface StoryProjection {
  perPaycheckCents: number;
  cadence: PayCadence;
  paycheckCount: number;
  paychecks: PaycheckRow[];
  savingsCents: number;
  availableCents: number;
  heldCents: number;
  interestCents: number;
  requestedPurchaseCents: number;
  purchaseCents: number;
  purchaseWasReduced: boolean;
  cashbackCents: number;
  paymentDateLabel: string;
  savingsAfterPaymentCents: number;
  availableAfterPaymentCents: number;
  heldAfterPaymentCents: number;
  nextSavingsCents: number;
  nextAvailableCents: number;
  nextPaycheckAvailableGainCents: number;
}

export interface StoryState {
  milestone: StoryMilestone;
  perPaycheckCents: number;
  cadence: PayCadence;
  paycheckCount: number;
}

export interface LedgerEntry {
  id: string;
  kind: LedgerKind;
  title: string;
  detail: string;
  dateLabel: string;
  amountCents: number;
  affectsSavings: boolean;
}
